export default {
	"delivery.ParameterError": "Parameter error!",
	"delivery.ShipmentStatus": "Shipment status",
	"delivery.Shipped": "Shipped",
	"delivery.ShippingTime": "Shipping time",
	"delivery.LogisticsTracking": "Logistics tracking",
	"delivery.ThereIsNoLogisticsInformation": "There is no logistics information",
	"delivery.ShippingAddress": "Shipping address"
}